import { getClientsLink } from '~/utils/getLinks';
import { useEditClientHeader } from './hooks';
import { EditClientHeaderPresentation } from './presentations';

type Props = {
  /** 利用企業ID */
  clientId: number;
};

/**
 * 利用企業編集ヘッダー Container
 *
 * - API から企業名を取得してパンくずリストを表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const EditClientHeader: React.FC<Props> = ({ clientId }) => {
  const { clientName } = useEditClientHeader({ clientId });

  return <EditClientHeaderPresentation clientName={clientName} indexHref={getClientsLink()} />;
};
